export enum Icons {
    adminUser = 'admin-user',
    analyticSidebar = 'analytic-sidebar',
    smartRouting = 'smart-routing',
    merchant = 'merchant',
    paymentsSidebar = 'payments-sidebar',
    refundsSidebar = 'refunds-sidebar',
    settlementsSidebar = 'settlements-sidebar',
    disputesSidebar = 'disputes-sidebar',
    individualPayoutsSidebar = 'individual-payouts-sidebar',
    bulkPayoutsSidebar = 'bulk-payouts-sidebar',
    settingsSidebar = 'settings-sidebar',
    offersSidebar = 'offers-sidebar',
    plansSidebar = 'plans-sidebar',
    subcriptionsSidebar = 'subscriptions-sidebar',
    paymentLinksSidebar = 'payment-links-sidebar',
    overviewSidebar = 'overview-sidebar',
    citiLogo = 'citi-logo',
    pluralLogo = 'plural-logo',
    reportsSidebar = 'reports-sidebar',
    partnerTransactionSidebar = 'partner-transaction-sidebar',
    partnerSummary = 'partner-summary',
    partnerAllMerchant = 'partner-all-merchant',
    brandWalletSidebar = 'brand-wallet-sidebar',
}
